import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconYoutube = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 39 28'>
    <title>{t('Youtube')}</title>
    <g fill='none' fillRule='evenodd'>
      <path d='M15.368149 19.3659673V7.87131429l10.1073673 5.74334691-10.1073673 5.7513061zM37.8432918 4.24749796c-.4441224-1.6682449-1.7534081-2.99265306-3.4128979-3.43677551-3.0157347-.81104082-15.103347-.81104082-15.103347-.81104082s-12.08681629 0-15.1033469.81104082C2.55625102 1.2548449 1.24696531 2.57925306.80284286 4.24749796c-.80308164 3.03881633-.80308164 9.36716324-.80308164 9.36716324s0 6.328347.80308164 9.3671633C1.2469653 24.6572327 2.55625102 25.9744776 4.2237 26.4186c3.01653061.8110408 15.1033469.8110408 15.1033469.8110408s12.0876123 0 15.103347-.8110408c1.6594898-.4441224 2.9687755-1.7613673 3.4128979-3.4367755.8110409-3.0388163.8110409-9.3671633.8110409-9.3671633s0-6.32834691-.8110409-9.36716324z'
        fill={fill} />
    </g>
  </svg>
)

export default Icon(IconYoutube)
